import { reactive, toRefs } from '@vue/composition-api';
import { NO_VALID_EMAIL_AVAILABILITY, ERROR_CHECK_USER_PROBLEM } from '@/js/utils/constants/constUser';
import { ERROR_PHONE_TOO_LONG } from '@/js/utils/constants/constErrorsCode';

import checkPhoneAvailability from '@/js/services/api/checkPhoneAvailability';

export default () => {
  const params = reactive({
    phone: '',
  });

  function checkPhoneAvailabilityHandler(phone) {
    return new Promise((resolve, reject) => checkPhoneAvailability(phone)
      .then((available) => {
        resolve(available);
      })
      .catch((e) => {
        if (e.code && e.code === NO_VALID_EMAIL_AVAILABILITY) {
          reject(e.message);
        } else if (e?.code === ERROR_PHONE_TOO_LONG) {
          reject(ERROR_CHECK_USER_PROBLEM.phoneTooLong);
        }
        resolve(false);
      }));
  }

  return {
    ...toRefs(params),
    checkPhoneAvailabilityHandler,
  };
};
